<div class="title-wrapper">
  <div class="label-wrapper" #labelWrapper>
    <cs-label #defaultLabel><ng-content></ng-content></cs-label>
    <ng-content select="cs-label"> </ng-content>
    <ng-content select="cs-badge"></ng-content>
    <ng-content select="cs-tooltip"></ng-content>
  </div>
  <ng-content select="cs-toggle"></ng-content>
  <ng-content select="cs-button"></ng-content>
</div>
<ng-content select="cs-note"></ng-content>
<ng-content select="help-link"></ng-content>